
const newModel = () => {
    return {
        vanhoaGiadinhVanhoaId: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        tenPhuongXa: null,
        phuongXaId: null,
        tsHo: null,
        soHoDk: null,
        tyLeDk: null,
        soHoDatGdvh: null,
        tyLeDatGdvh: null,
        soHoKhongdatGdvh: null,
        tyLeKhongdatGdvh: null,
        tsHoGdCoTreEm: null,
        soHoGdCoTreEmDatGdvh: null,
        tyLeGdCoTreEmDatGdvh: null,
        soHoGdCoTreEmKhongdatGdvh: null,
        tyLeGdCoTreEmKhongdatGdvh: null,
        tsHoGdKhongTreEm: null,
        soHoGdKhongTreEmDatGdvh: null,
        tyLeGdKhongTreEmDatGdvh: null,
        soHoGdKhongTreEmKhongdatGdvh: null,
        tyLeGdKhongTreEmKhongdatGdvh: null,
        tsHo3nam: null,
        hoDat3nam: null,
        tyleHoDat3nam: null,
        soHoDuocKhenThuong3nam: null,
        tyleDuocKhenthuong3nam: null,
        soHoDkNamsau: null,
        tyleHoDkNamsau: null,
        idKy: null,
        tenKy: null,
        ghiChu: null,

        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        vanhoaGiadinhVanhoaId: null,
        quanHuyenId: null,
        phuongXaId: null,
        tsHo: null,
        soHoDk: null,
        tyLeDk: null,
        soHoDatGdvh: null,
        tyLeDatGdvh: null,
        soHoKhongdatGdvh: null,
        tyLeKhongdatGdvh: null,
        tsHoGdCoTreEm: null,
        soHoGdCoTreEmDatGdvh: null,
        tyLeGdCoTreEmDatGdvh: null,
        soHoGdCoTreEmKhongdatGdvh: null,
        tyLeGdCoTreEmKhongdatGdvh: null,
        tsHoGdKhongTreEm: null,
        soHoGdKhongTreEmDatGdvh: null,
        tyLeGdKhongTreEmDatGdvh: null,
        soHoGdKhongTreEmKhongdatGdvh: null,
        tyLeGdKhongTreEmKhongdatGdvh: null,
        tsHo3nam: null,
        hoDat3nam: null,
        tyleHoDat3nam: null,
        soHoDuocKhenThuong3nam: null,
        tyleDuocKhenthuong3nam: null,
        soHoDkNamsau: null,
        tyleHoDkNamsau: null,
        idKy: null,
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        vanhoaGiadinhVanhoaId: item.vanhoaGiadinhVanhoaId,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        tsHo: item.tsHo,
        soHoDk: item.soHoDk,
        tyLeDk: item.tyLeDk,
        soHoDatGdvh: item.soHoDatGdvh,
        tyLeDatGdvh: item.tyLeDatGdvh,
        soHoKhongdatGdvh: item.soHoKhongdatGdvh,
        tyLeKhongdatGdvh: item.tyLeKhongdatGdvh,
        tsHoGdCoTreEm: item.tsHoGdCoTreEm,
        soHoGdCoTreEmDatGdvh: item.soHoGdCoTreEmDatGdvh,
        tyLeGdCoTreEmDatGdvh: item.tyLeGdCoTreEmDatGdvh,
        soHoGdCoTreEmKhongdatGdvh: item.soHoGdCoTreEmKhongdatGdvh,
        tyLeGdCoTreEmKhongdatGdvh: item.tyLeGdCoTreEmKhongdatGdvh,
        tsHoGdKhongTreEm: item.tsHoGdKhongTreEm,
        soHoGdKhongTreEmDatGdvh: item.soHoGdKhongTreEmDatGdvh,
        tyLeGdKhongTreEmDatGdvh: item.tyLeGdKhongTreEmDatGdvh,
        soHoGdKhongTreEmKhongdatGdvh: item.soHoGdKhongTreEmKhongdatGdvh,
        tyLeGdKhongTreEmKhongdatGdvh: item.tyLeGdKhongTreEmKhongdatGdvh,
        tsHo3nam: item.tsHo3nam,
        hoDat3nam: item.hoDat3nam,
        tyleHoDat3nam: item.tyleHoDat3nam,
        soHoDuocKhenThuong3nam: item.soHoDuocKhenThuong3nam,
        tyleDuocKhenthuong3nam: item.tyleDuocKhenthuong3nam,
        soHoDkNamsau: item.soHoDkNamsau,
        tyleHoDkNamsau: item.tyleHoDkNamsau,
        idKy: item.idKy,
        tenKy: item.tenKy,
        ghiChu: item.ghiChu,
        
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        vanhoaGiadinhVanhoaId: item.vanhoaGiadinhVanhoaId,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        tsHo: item.tsHo,
        soHoDk: item.soHoDk,
        tyLeDk: item.tyLeDk,
        soHoDatGdvh: item.soHoDatGdvh,
        tyLeDatGdvh: item.tyLeDatGdvh,
        soHoKhongdatGdvh: item.soHoKhongdatGdvh,
        tyLeKhongdatGdvh: item.tyLeKhongdatGdvh,
        tsHoGdCoTreEm: item.tsHoGdCoTreEm,
        soHoGdCoTreEmDatGdvh: item.soHoGdCoTreEmDatGdvh,
        tyLeGdCoTreEmDatGdvh: item.tyLeGdCoTreEmDatGdvh,
        soHoGdCoTreEmKhongdatGdvh: item.soHoGdCoTreEmKhongdatGdvh,
        tyLeGdCoTreEmKhongdatGdvh: item.tyLeGdCoTreEmKhongdatGdvh,
        tsHoGdKhongTreEm: item.tsHoGdKhongTreEm,
        soHoGdKhongTreEmDatGdvh: item.soHoGdKhongTreEmDatGdvh,
        tyLeGdKhongTreEmDatGdvh: item.tyLeGdKhongTreEmDatGdvh,
        soHoGdKhongTreEmKhongdatGdvh: item.soHoGdKhongTreEmKhongdatGdvh,
        tyLeGdKhongTreEmKhongdatGdvh: item.tyLeGdKhongTreEmKhongdatGdvh,
        tsHo3nam: item.tsHo3nam,
        hoDat3nam: item.hoDat3nam,
        tyleHoDat3nam: item.tyleHoDat3nam,
        soHoDuocKhenThuong3nam: item.soHoDuocKhenThuong3nam,
        tyleDuocKhenthuong3nam: item.tyleDuocKhenthuong3nam,
        soHoDkNamsau: item.soHoDkNamsau,
        tyleHoDkNamsau: item.tyleHoDkNamsau,
        idKy: item.idKy,
        tenKy: item.tenKy,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const errors = () => {
    return {
        vanhoaGiadinhVanhoaId: null,
        quanHuyenId: null,
        phuongXaId: null,
        tsHo: null,
        soHoDk: null,
        tyLeDk: null,
        soHoDatGdvh: null,
        tyLeDatGdvh: null,
        soHoKhongdatGdvh: null,
        tyLeKhongdatGdvh: null,
        tsHoGdCoTreEm: null,
        soHoGdCoTreEmDatGdvh: null,
        tyLeGdCoTreEmDatGdvh: null,
        soHoGdCoTreEmKhongdatGdvh: null,
        tyLeGdCoTreEmKhongdatGdvh: null,
        tsHoGdKhongTreEm: null,
        soHoGdKhongTreEmDatGdvh: null,
        tyLeGdKhongTreEmDatGdvh: null,
        soHoGdKhongTreEmKhongdatGdvh: null,
        tyLeGdKhongTreEmKhongdatGdvh: null,
        tsHo3nam: null,
        hoDat3nam: null,
        tyleHoDat3nam: null,
        soHoDuocKhenThuong3nam: null,
        tyleDuocKhenthuong3nam: null,
        soHoDkNamsau: null,
        tyleHoDkNamsau: null,
        idKy: null,
        ghiChu: null,
        enabled: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        phuongXaId: null,
        idKy: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        phuongXaId: null,
        idKy: null,
        enabled: null,
    }
}

export const giaDinhVanHoaVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


